import loadable from '@loadable/component';


export default loadable(
  () => import(/* webpackChunkName: "user.mobileVerification" */ '../layouts/MobileVerification'),
);
